import type { ContributionTimeSeriesPoint } from "@/lib/types/stats";

export interface DayActivity {
  /** YYYY-MM-DD, local day. */
  date: string;
  contributions: number;
}

const dayKey = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

/**
 * The last seven days ending today, one entry per day, zero when the series
 * has no point for it. Points may carry a full timestamp; only the day counts.
 */
export function lastSevenDays(series: ContributionTimeSeriesPoint[] | undefined, today = new Date()): DayActivity[] {
  const totals = new Map<string, number>();
  for (const point of series ?? []) {
    const key = point.date.slice(0, 10);
    totals.set(key, (totals.get(key) ?? 0) + (point.contributions ?? 0));
  }
  return Array.from({ length: 7 }, (_, i) => {
    const day = new Date(today.getFullYear(), today.getMonth(), today.getDate() - (6 - i));
    const date = dayKey(day);
    return { date, contributions: totals.get(date) ?? 0 };
  });
}

/** First name to greet with: the profile name, else the username. */
export function greetingName(user: { name?: string | null; username?: string | null } | null | undefined): string {
  const name = user?.name?.trim() || user?.username?.trim() || "";
  return name.split(/\s+/)[0] ?? "";
}
